import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, Subject } from "rxjs";

import { AuthServices } from "../auth.service";
import { Injectable } from "@angular/core";
import { endpoints } from "src/app/_config/url-endpoint";

@Injectable({
  providedIn: "root",
})
export class RentalService {
  private saveRentalVal = new Subject<any>();

  constructor(private http: HttpClient, private authService: AuthServices) {}

   /**
   * rental Analytic
   *   
   * @returns {Observable<any>}
   * @memberof RentalService
   */

  getRentalAnalytics(tenantId): Observable<any> {
    let url = `${endpoints.rental.rentalAnalyticsUrl}?tenantId=${tenantId}`;
    return this.http.get(url, this.authService.getAccessHeaders());
  }

  /**
   * rentals 
   * 
   * @param {string} queryString  
   * @returns {Observable<any>}
   * @memberof RentalService
   */

  getRental(queryString): Observable<any> {
    let url = `${endpoints.rental.assetUrl}?${queryString}`;
    return this.http.get(url, this.authService.getAccessHeaders());
  }

  /**
   * Miscellaneous 
   * 
   * @param {string} partnerId  
   * @returns {Observable<any>}
   * @memberof RentalService
   */

  // getMiscellaneous(partnerId?: string): Observable<any> {
  //   let url = `${endpoints.rental.miscellaneous}`;
  //   if (partnerId) {
  //     url = `${endpoints.rental.miscellaneous}?partnerId=${partnerId}`;
  //   }
  //   return this.http.get(url, this.authService.getAccessHeaders());
  // }
  getMiscellaneous(partnerId?: string, availableDays?: string): Observable<any> {
    let url = `${endpoints.rental.miscellaneousUrl}`;
    
    const params = new URLSearchParams();
    if (partnerId) {
      params.append("partnerId", partnerId);
    }
    if (availableDays) {
      params.append("availableDays", availableDays);
    }
  
    return this.http.get(`${url}?${params.toString()}`, this.authService.getAccessHeaders());
  }
    /**
   * Facility 
   * 
   * @returns {Observable<any>}
   * @memberof RentalService
   */

  getFacility(): Observable<any> {
    let url = `${endpoints.rental.facilitiesUrl}`;
    return this.http.get(url, this.authService.getAccessHeaders());
  }

  /**
   * Amenities 
   * 
 
   * @returns {Observable<any>}
   * @memberof RentalService
   */

  getAmenities(): Observable<any> {
    let url = `${endpoints.rental.amenitiesUrl}`;
    return this.http.get(url, this.authService.getAccessHeaders());
  }

   /**
   * Water Sports 
   * 
   * @param {string} partnerId  
   * @returns {Observable<any>}
   * @memberof RentalService
   */

  // getWaterSports(partnerId?: string): Observable<any> {
  //   let url = `${endpoints.rental.waterSportsUrl}`;
  //   if (partnerId) {
  //     url = `${endpoints.rental.waterSportsUrl}?partnerId=${partnerId}`;
  //   }
  //   return this.http.get(url, this.authService.getAccessHeaders());
  // }
//   getWaterSports(partnerId?: string, availableDays?: string): Observable<any> {
//     let url = `${endpoints.rental.waterSportsUrl}`;
    
//     const params = new URLSearchParams();
//     if (partnerId) {
//       params.append("partnerId", partnerId);
//     }
//     if (availableDays) {
//       params.append("availableDays", availableDays);
//     }
  
//     return this.http.get(`${url}?${params.toString()}`, this.authService.getAccessHeaders());
//   }
  /**
   * Caterings
   * 
   * @param {string} partnerId  
   * @returns {Observable<any>}
   * @memberof RentalService
   */

  // getCaterings(partnerId?: string): Observable<any> {
  //   let url = `${endpoints.rental.cateringUrl}`;
  //   if (partnerId) {
  //     url = `${endpoints.rental.cateringUrl}?partnerId=${partnerId}`;
  //   }
  //   return this.http.get(url, this.authService.getAccessHeaders());
  // }
  getCaterings(partnerId?: string, availableDays?: string): Observable<any> {
    let url = `${endpoints.rental.cateringUrl}`;
    
    const params = new URLSearchParams();
    if (partnerId) {
      params.append("partnerId", partnerId);
    }
    if (availableDays) {
      params.append("availableDays", availableDays);
    }
  
    return this.http.get(`${url}?${params.toString()}`, this.authService.getAccessHeaders());
  }
 
  /**
   * Routes
   * 
   * @param {string} tenantId  
   * @returns {Observable<any>}
   * @memberof RentalService
   */



  
  /**
   * rental Details
   * 
   * @param {string} rentalId  
   * @returns {Observable<any>}
   * @memberof RentalService
   */


  getRentalDetails(rentalId): Observable<any> {
    return this.http.get(endpoints.rental.assetUrl + `/${rentalId}`, this.authService.getAccessHeaders());
  }

  /**
   * Create rental
   * 
   * @param {string} body  
   * @returns {Observable<any>}
   * @memberof RentalService
   */

  createRental(body): Observable<any> {
    return this.http.post(`${endpoints.rental.assetUrl}`, body, this.authService.getAccessHeaders());
  }

 /**
   * Edit rental
   * 
   * @param {string} rentalId 
   * @param {string} body  
   * @returns {Observable<any>}
   * @memberof RentalService
   */

  editRental(rentalId, body): Observable<any> {
    return this.http.patch(endpoints.rental.assetUrl + `/${rentalId}`, body, this.authService.getAccessHeaders());
  }

  /**
   * Admin review of Mulkiya / registration card documents (per side).
   */
  updateMulkiyaDocuments(rentalId: string, body: Record<string, unknown>): Observable<any> {
    return this.http.patch(
      `${endpoints.rental.assetUrl}/${rentalId}/mulkiya-documents`,
      body,
      this.authService.getAccessHeaders()
    );
  }

  /**
   * Paginated Mulkiya document history snapshots for an asset.
   */
  getMulkiyaDocumentsHistory(
    rentalId: string,
    pageNumber = 1,
    perPage = 12
  ): Observable<any> {
    const params = new URLSearchParams();
    params.append("pageNumber", String(pageNumber));
    params.append("perPage", String(perPage));
    return this.http.get(
      `${endpoints.rental.assetUrl}/${rentalId}/mulkiya-documents?${params.toString()}`,
      this.authService.getAccessHeaders()
    );
  }

  /**
   *
   *
   * @param {string} [tenantId]
   * @returns {Observable<any>}
   * @memberof RentalService
   */
  
  getRentalCount(tenantId?: string): Observable<any> {
    let tenantUrlString = "";
    if (tenantId) {
      tenantUrlString = `?tenantId=${tenantId}`;
    }
    let url = `${endpoints.rental.rentalStatusCountUrl}${tenantUrlString}`;
    return this.http.get(url, this.authService.getAccessHeaders());
  }

 /**
   * Change rental Status
   * 
   * @param {string} rentalId 
   * @param {string} body  
   * @returns {Observable<any>}
   * @memberof RentalService
   */

  changeRentalStatus(rentalId, body): Observable<any> {
    return this.http.post(`${endpoints.rental.rentalActionUrl}/${rentalId}`, body, this.authService.getAccessHeaders());
  }

  /**
   * downloadFile
   * 
   * @param {string} queryParams
   * @returns {Observable<any>}
   * @memberof RentalService
   */


  downloadFile(queryParams): Observable<any> {
    const url = `${endpoints.rental.rentalDownloadUrl}?${queryParams}`;
    return this.http.get(url, {
      headers: (this.authService.getAccessHeaders() as { headers: HttpHeaders }).headers,
      responseType: "blob",
    });
  }

  // getAddons(addons): Observable<any> {
  //   let url = `${endpoints.rental.addonsUrl}?id=${addons}`;
  //   return this.http.get(url, this.authService.getAccessHeaders());
  // }
  getAddons(rentalId: string, type: string): Observable<any> {
    const url = `${endpoints.rental.addonsUrl}?id=${rentalId}&type=${type}`;
    return this.http.get(url, this.authService.getAccessHeaders());
  }

  // done
  public setRefreshRental(data: any) {
    this.saveRentalVal.next({ result: data });
  }

  // done
  public getRefreshRental(): Observable<any> {
    return this.saveRentalVal.asObservable();
  }


    getInsurance(payload?: string): Observable<any> {
    let url = `${endpoints.rental.insuranceUrl}`;
    if (payload) {
      url = `${url}?${payload}`;
    }

    return this.http.get(url, this.authService.getAccessHeaders());
  }
}

